<div class="sw-cms-block-moorl-column-layout-3-2">
    <slot name="slot-a"></slot>
    <slot name="slot-b"></slot>
</div>